<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>

    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important" toggleable="lg" type="dark" variant="primary">
          <b-navbar-brand center>Pricing Engine Form</b-navbar-brand>
          <b-navbar-nav>
            <b-button @click="goBack" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
        </b-navbar>
        <b-card class="formCard">
          <b-card-text>
            <b-row>
              <b-col class="col-md-3 mb-2">
                <label>Shipping Line<span class="error">*</span></label>
                <model-list-select :isDisabled="
                    $sessionsStorage.get('designation') != 'Admin' &&
                    $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                    enqPriceEngineForm.enq_price_engine_id
                      ? true
                      : false
                  " :list="$store.getters['common/getAllShippingLineList']" v-model="enqPriceEngineForm.fk_sline_id"
                  @input="getSlineBaseEnqPriceEngine(enqPriceEngineForm.fk_sline_id)" option-value="shippingId"
                  option-text="shippingLine" placeholder="Select Shipping Line"></model-list-select>
                <span class="error" v-if="!enqPriceEngineForm.fk_sline_id">
                  {{ errorList.fk_sline_id }}
                </span>
              </b-col>
              <!-- <b-col class="col-md-3 mb-2">
                <label>Commodity Type <span class="error">*</span></label>
                <model-list-select
                  :isDisabled="enqPriceEngineForm.enq_price_engine_id ? true : false"
                  :list="commodityTypeNameList"
                  v-model="enqPriceEngineForm.commodity_type"
                  option-value="commodityTypeVal"
                  option-text="commodityTypeText"
                  placeholder="Select Commodity Type"
                ></model-list-select>
                <span class="error" v-if="!enqPriceEngineForm.commodity_type">
                  {{ errorList.commodity_type }}
                </span>
              </b-col> -->

              <!-- class="table-responsive tableMain" -->
              <b-col md="12" v-if="enqPriceEngineForm.fk_sline_id">
                <table class="table table-sm table-bordered mt-2">
                  <tbody style="background: white">
                    <tr v-if="PricingEngineCountArr.length > 0">
                      <th scope="col" style="width: 5px">SN.</th>
                      <th scope="col" style="width: 200px">Commodity</th>
                      <!-- <th scope="col" style="width: 200px">POR</th> -->
                      <th scope="col" style="width: 200px">POL</th>
                      <th scope="col" style="width: 200px">POD</th>
                      <!-- <th scope="col" style="width: 200px">FPOD</th> -->
                      <th scope="col" style="width: 200px">Container Type</th>
                      <th scope="col" style="width: 200px">Currency</th>
                      <th scope="col" style="width: 200px">AMT</th>
                      <th scope="col" style="width: 180px">Additional Charges AMT</th>
                      <th scope="col" style="width: 180px">Total AMT</th>
                      <!-- <th scope="col" style="width: 180px">OF-40 HC</th>
                      <th scope="col" style="width: 180px">Additional Charges-40 HC</th>
                      <th scope="col" style="width: 180px">Total 40 HC</th> -->
                      <th scope="col" style="width: 180px">Free Time</th>
                      <th scope="col" style="width: 180px">Validity Date</th>
                      <th scope="col" style="width: 180px">Handover/Gate IN/Sailing</th>
                      <th scope="col" style="width: 5px">
                        Actions
                        <b-button @click="addPricingEngineCount()" size="sm">
                          <i class="fa fa-plus-circle ml-1"></i>
                        </b-button>
                      </th>
                    </tr>
                    <tr v-for="(item, index) in PricingEngineCountArr" :key="index">
                      <th scope="row">{{ index + 1 }}.</th>
                      <td>
                        <model-list-select :isDisabled="item.enq_price_engine_id ? true : false"
                          :list="commodityTypeNameList" v-model="item.commodity_type" option-value="commodityTypeVal"
                          option-text="commodityTypeText" placeholder="Select Commodity Type"></model-list-select>
                        <span class="error" v-if="item.commodity_type_err ? true : false">
                          {{ item.commodity_type_err }}
                        </span>
                      </td>
                      <!-- <td>
                        <model-list-select
                          :isDisabled="
                            $sessionsStorage.get('designation') != 'Admin' &&
                            $sessionsStorage.get('nameUser') != 'Bhavneesh' &&
                            enqPriceEngineForm.enq_price_engine_id
                              ? true
                              : false
                          "
                          @input="getLocationList($event, 'All', 'IcdPOrtList')"
                          @searchchange="getLocationList($event, 'All', 'IcdPOrtList')"
                          :list="
                            $store.getters[
                              'enqPriceEngineDropdown/getAllEnqPriceEnginePORDDList'
                            ]
                          "
                          v-model="item.fk_por_id"
                          option-value="pickupId"
                          option-text="pickupLocation"
                          placeholder="Select POR"
                        ></model-list-select>
                        <span class="error" v-if="item.fk_por_id_err ? true : false">{{
                          item.fk_por_id_err
                        }}</span>
                      </td> -->
                      <td>
                        <model-list-select :isDisabled="item.enq_price_engine_id ? true : false"
                          @input="getLocationList($event, 'All', 'PortLoadList')"
                          @searchchange="getLocationList($event, 'All', 'PortLoadList')" :list="
                            $store.getters[
                              'enqPriceEngineDropdown/getAllEnqPriceEnginePOLDDList'
                            ]
                          " v-model="item.fk_pol_id" option-value="pickupId" option-text="pickupLocation"
                          placeholder="Select POL"></model-list-select>
                        <span class="error" v-if="item.fk_pol_id_err ? true : false">{{
                          item.fk_pol_id_err
                          }}</span>
                      </td>
                      <td>
                        <model-list-select :isDisabled="item.enq_price_engine_id ? true : false"
                          @input="getLocationList($event, 'All', 'getPortDischargeList')" @searchchange="
                            getLocationList($event, 'All', 'getPortDischargeList')
                          " :list="
                            getPortDischargeList.length > 0
                              ? getPortDischargeList
                              : $store.getters[
                                  'enqPriceEngineDropdown/getAllEnqPriceEnginePODDDList'
                                ]
                          " v-model="item.fk_pod_id" option-value="pickupId" option-text="pickupLocation"
                          placeholder="Select POD"></model-list-select>
                        <span class="error" v-if="item.fk_pod_id_err ? true : false">{{
                          item.fk_pod_id_err
                          }}</span>
                      </td>
                      <!-- <td>
                        <model-list-select
                          :isDisabled="item.enq_price_engine_id ? true : false"
                          @input="getLocationList($event, 'All', 'getPortDischargeList')"
                          @searchchange="
                            getLocationList($event, 'All', 'getPortDischargeList')
                          "
                          :list="
                            getPortDischargeList.length > 0
                              ? getPortDischargeList
                              : $store.getters[
                                  'enqPriceEngineDropdown/getAllEnqPriceEngineFPODDDList'
                                ]
                          "
                          v-model="item.fk_fpod_id"
                          option-value="pickupId"
                          option-text="pickupLocation"
                          placeholder="Select FPOD"
                        ></model-list-select>
                        <span class="error" v-if="item.fk_fpod_id_err ? true : false">{{
                          item.fk_fpod_id_err
                        }}</span>
                      </td> -->
                      <td>
                        <model-list-select :isDisabled="item.enq_price_engine_id ? true : false"
                          :list="$store.getters['common/getAllContainerTypeList']" v-model="item.fk_cont_type_id"
                          option-value="containerTypeId" option-text="containerType"
                          placeholder="Select Container Type"></model-list-select>
                        <span class="error" v-if="item.fk_cont_type_id_err ? true : false">{{ item.fk_cont_type_id_err
                          }}</span>
                      </td>
                      <td>
                        <model-list-select :list="$store.getters['common/getAllCurrencyList']"
                          v-model="item.fk_currency_id" option-value="currency_id" option-text="currencyCode"
                          placeholder="Select Currency"></model-list-select>
                        <span class="error" v-if="item.fk_currency_id_err ? true : false">{{ item.fk_currency_id_err
                          }}</span>
                      </td>
                      <td>
                        <b-form-input :disabled="enqPriceEng_EditFlag" :formatter="capitalizeAll"
                          v-model="item.of_twenty_gp" type="number" @input="CheckValueNumbers($event)"
                          @change="CheckValueNumbers($event)" v-on:keyup="TotalAMT(item, index)" @wheel="handleWheel"
                          placeholder="Enter OF-20"></b-form-input>
                        <span class="error" v-if="item.of_twenty_gp_err ? true : false">{{
                          item.of_twenty_gp_err
                          }}</span>
                      </td>
                      <td>
                        <b-form-input :disabled="enqPriceEng_EditFlag" :formatter="capitalizeAll"
                          v-model="item.twenty_gp_add_charg" type="number" @input="CheckValueNumbers($event)"
                          @change="CheckValueNumbers($event)" v-on:keyup="TotalAMT(item, index)" @wheel="handleWheel"
                          placeholder="Enter Additional Charges-20"></b-form-input>
                        <span class="error" v-if="item.twenty_gp_add_charg_err ? true : false">{{
                          item.twenty_gp_add_charg_err }}</span>
                      </td>
                      <td>
                        <b-form-input :disabled="true" :formatter="capitalizeAll" v-model="item.tot_twenty_gp"
                          type="number" @input="CheckValueNumbers($event)" @change="CheckValueNumbers($event)"
                          v-on:keyup="TotalAMT(item, index)" @wheel="handleWheel"
                          placeholder="Enter Total 20"></b-form-input>
                        <span class="error" v-if="item.tot_twenty_gp_err ? true : false">{{ item.tot_twenty_gp_err
                          }}</span>
                      </td>

                      <!-- <td>
                        <b-form-input
                          :disabled="enqPriceEng_EditFlag"
                          :formatter="capitalizeAll"
                          v-model="item.of_fourty_hc"
                          type="number"
                          @input="CheckValueNumbers($event)"
                          @change="CheckValueNumbers($event)"
                          v-on:keyup="TotalAMT(item, index)"
                          @wheel="handleWheel"
                          placeholder="Enter OF-40 HC"
                        ></b-form-input>
                        <span class="error" v-if="item.of_fourty_hc_err ? true : false">{{
                          item.of_fourty_hc_err
                        }}</span>
                      </td>
                      <td>
                        <b-form-input
                          :disabled="enqPriceEng_EditFlag"
                          :formatter="capitalizeAll"
                          v-model="item.fourty_hc_add_charg"
                          type="number"
                          @input="CheckValueNumbers($event)"
                          @change="CheckValueNumbers($event)"
                          v-on:keyup="TotalAMT(item, index)"
                          @wheel="handleWheel"
                          placeholder="Enter Additional Charges-40 HC"
                        ></b-form-input>
                        <span
                          class="error"
                          v-if="item.fourty_hc_add_charg_err ? true : false"
                          >{{ item.fourty_hc_add_charg_err }}</span
                        >
                      </td>
                      <td>
                        <b-form-input
                          :disabled="true"
                          :formatter="capitalizeAll"
                          v-model="item.tot_fourty_hc"
                          type="number"
                          @input="CheckValueNumbers($event)"
                          @change="CheckValueNumbers($event)"
                          v-on:keyup="TotalAMT(item, index)"
                          @wheel="handleWheel"
                          placeholder="Enter Total 40 HC"
                        ></b-form-input>
                        <span
                          class="error"
                          v-if="item.tot_fourty_hc_err ? true : false"
                          >{{ item.tot_fourty_hc_err }}</span
                        >
                      </td> -->

                      <td>
                        <b-form-input :disabled="enqPriceEng_EditFlag" :formatter="capitalizeAll"
                          v-model="item.free_time" type="number" @wheel="handleWheel" min="1" max="50"
                          placeholder="Enter Free Time"></b-form-input>
                        <span class="error" v-if="item.free_time_err ? true : false">{{
                          item.free_time_err
                          }}</span>
                      </td>
                      <td>
                        <span :class="item.expire_status == 'Active' ? 'primary' : 'error'"
                          v-if="item.expire_status ? true : false">{{ item.expire_status }} Validity Date
                        </span>
                        <date-picker :disabled="
                            item.expire_status == 'Expired' || item.is_new == 1
                              ? false
                              : true
                          " style="margin-top: 8px" lang="en" :format="selectDateFormat" id="validityDate"
                          name="validityDate" placeholder="Enter Validity Date" :not-before="calculateMinDate()"
                          v-model="item.validity_date"></date-picker>
                        <b-button v-if="item.expire_status == 'Expired' && item.is_new == 2" class="smbutnWidth"
                          variant="primary" size="sm" style="font-size: 0.675rem" id="updateValidityDate" @click="
                            updateValidityDate(
                              item,
                              item.pre_validityDate,
                              item.validity_date
                            )
                          ">Extend</b-button>

                        <!-- <b-form-input
                          :disabled="enqPriceEng_EditFlag"
                          :formatter="capitalizeAll"
                          v-model="item.validity_date"
                          type="date"
                          :minDate="calculateMinDate()"
                          placeholder="Enter Validity Date"
                        ></b-form-input> -->
                        <!-- {{item.validity_date_err}} -->
                        <span class="error" v-if="item.validity_date_err ? true : false">{{ item.validity_date_err
                          }}</span>
                        <span class="error">{{
                          item.validity_date_expire_status_err
                          }}</span>
                      </td>
                      <td>
                        <model-list-select :isDisabled="item.enq_price_engine_id ? true : false" :list="handOverList"
                          v-model="item.handover" option-value="handVal" option-text="handText"
                          placeholder="Select Type"></model-list-select>
                        <span class="error" v-if="item.handover_err ? true : false">
                          {{ item.handover_err }}
                        </span>
                        <!-- <b-form-input
                          :disabled="enqPriceEng_EditFlag"
                          :formatter="capitalizeAll"
                          v-model="item.handover"
                          type="text"
                          placeholder="Enter Handover/Gate IN/Sailing"
                        ></b-form-input> -->
                        <!-- <span class="error" v-if="item.handover_err ? true : false">{{
                          item.handover_err
                        }}</span> -->
                      </td>
                      <td>
                        <b-button v-if="index > 0" size="sm" @click="removePricingEngineCount(index)"
                          :disabled="item.enq_price_engine_id ? true : false">
                          <i class="fa fa-minus-circle" aria-hidden="true"></i>
                        </b-button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-col>
              <hr />
            </b-row>
            <b-row>
              <b-col md="3"></b-col>
              <b-col md="3">
                <b-button v-if="
                    ($sessionsStorage.get('designation') == 'Admin' &&
                      $sessionsStorage.get('nameUser') == 'Bhavneesh') ||
                    (!enqPriceEngineForm.enq_price_engine_id || enqPriceEngineForm.enq_price_engine_id)
                      ? true
                      : false
                  " size="sm" class="pull-right" style="margin:left:5px" variant="primary"
                  @click="addenqPriceEngineForm">{{
                  enqPriceEngineForm.enq_price_engine_id ? "Update" : "Save"
                  }}</b-button>
                  <!-- {{ enqPriceEngineForm.enq_price_engine_id }} -->
                <h6>
                  <span v-if="enqPriceEngineForm.createdBy" class="error">Created By : {{ enqPriceEngineForm.createdBy
                    }}</span><span v-if="enqPriceEngineForm.created_at" class="error">
                    Created At : {{ enqPriceEngineForm.created_at }}</span>
                </h6>
              </b-col>
              <b-col md="3"></b-col>
            </b-row>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>

<script src="https://unpkg.com/vue/dist/vue.js"></script>
<script src="https://unpkg.com/vue2-editor/dist/vue2-editor.umd.min.js"></script>
<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import {
  globalPermissionStatus,
  GlobalGetLocation,
  GlobalGetCommodity,
} from "../../helper/collection";
import LeadService from "../../services/LeadService.js";
import CustomLoader from "../common/customLoader.vue";

export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("edit_enq_price_engine_id") != undefined &&
      this.$sessionsStorage.get("edit_enq_price_engine_id") != null &&
      this.$sessionsStorage.get("edit_enq_price_engine_id") != ""
    ) {
      // alert(this.$sessionsStorage.get("edit_enq_price_engine_id"))
      this.getSingleEnqPriceEngine(
        this.$sessionsStorage.get("edit_enq_price_engine_id"),
        this.$sessionsStorage.get("edit_enq_price_engine_sline_id")
      );
    }
    let payload = {
      Currency: "Currency_DropDown",
    };
    this.$store.dispatch("common/setAllCurrencyList", JSON.stringify(payload));
    // Sea Section Start
    this.$store.dispatch(
      "common/setAllShippingLineList",
      JSON.stringify({
        itemCode: "ShippingLineList",
      })
    );
    this.$store.dispatch(
      "common/setAllContainerTypeList",
      JSON.stringify({
        itemCode: "ContainerTypeList",
      })
    );
    this.$store.dispatch(
      "enqPriceEngineDropdown/setAllEnqPriceEnginePODDDList",
      JSON.stringify({
        itemCode: "getAllEnqPriceEnginePODDDList",
      })
    );
       this.$store.dispatch(
      "enqPriceEngineDropdown/setAllEnqPriceEngineFPODDDList",
      JSON.stringify({
        itemCode: "getAllEnqPriceEngineFPODDDList",
      })
    );
    this.$store.dispatch(
      "enqPriceEngineDropdown/setAllEnqPriceEnginePOLDDList",
      JSON.stringify({
        itemCode: "getAllEnqPriceEnginePOLDDList",
      })
    );

    this.$store.dispatch(
      "enqPriceEngineDropdown/setAllEnqPriceEnginePORDDList",
      JSON.stringify({
        itemCode: "getAllEnqPriceEnginePORDDList",
      })
    );

    // Import DropDown Start
    this.$store.dispatch(
      "enqPriceEngineDropdown/setAllEnqPriceEngineIMPPODDDList",
      JSON.stringify({
        itemCode: "getAllEnqPriceEngineIMPPODDDList",
      })
    );
    this.$store.dispatch(
      "enqPriceEngineDropdown/setAllEnqPriceEngineIMPPOLDDList",
      JSON.stringify({
        itemCode: "getAllEnqPriceEngineIMPPOLDDList",
      })
    );
    this.$store.dispatch(
      "enqPriceEngineDropdown/setAllEnqPriceEngineIMPFPODDDList",
      JSON.stringify({
        itemCode: "getAllEnqPriceEngineIMPFPODDDList",
      })
    );
    this.$store.dispatch(
      "enqPriceEngineDropdown/setAllEnqPriceEngineIMPPORDDList",
      JSON.stringify({
        itemCode: "getAllEnqPriceEngineIMPPORDDList",
      })
    );
    // Import DropDown End

    // Sea Section End

    if (globalPermissionStatus("Enq. For Pricing")) {
      this.$store.dispatch("setCurrentRoute", "/pricing/upsertPricingEngine");
      // this.getSingleEnqPriceEngine();
      this.windowSize = $(window).width();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
    // this.getEnqPricingEngineList();
  },
  watch: {},
  data() {
    return {
      enqPriceEng_EditFlag: false,
      validatePriceEngine: true,
      PricingEngineCountArr: [
        {
          enq_price_engine_id: "",
          commodity_type: "",
          // fk_por_id: "",
          fk_pol_id: "",
          fk_pod_id: "",
          // fk_fpod_id: "",
          fk_currency_id: "1",
          fk_cont_type_id: "1",
          of_twenty_gp: "",
          twenty_gp_add_charg: "",
          tot_twenty_gp: "",
          // of_fourty_hc: "",
          // fourty_hc_add_charg: "",
          // tot_fourty_hc: "",
          free_time: "",
          validity_date: "",
          handover: "",
          expire_status: "",

          commodity_type_err: "",
          // fk_por_id_err: "",
          fk_pol_id_err: "",
          fk_pod_id_err: "",
          // fk_fpod_id_err: "",
          fk_currency_id_err: "",
          fk_cont_type_id_err: "",
          of_twenty_gp_err: "",
          twenty_gp_add_charg_err: "",
          // tot_twenty_gp_err: "",
          // of_fourty_hc_err: "",
          // fourty_hc_add_charg_err: "",
          tot_fourty_hc_err: "",
          free_time_err: "",
          validity_date_err: "",
          validity_date_expire_status_err: "",
          handover_err: "",
          pre_validityDate: "",
          is_new: 1,
        },
      ],
      getPortDischargeList: [],
      finalAllPlaceData: [],
      EnqPricingEngineList: [],

      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      enqPriceEngineForm: {
        enq_price_engine_id: "",
        fk_sline_id: "",
        PricingEngineCount: [],
        is_active: true,
        created_at: "",
        createdBy: "",
      },
      handOverList: [
        {
          handText: "HANDOVER",
          handVal: "HANDOVER",
        },
        {
          handText: "GATE IN",
          handVal: "GATE IN",
        },
        {
          handText: "SAILING",
          handVal: "SAILING",
        },
      ],
      enqPriceEngineFormError: [
        "Please Select Shipping Line",
        // "Please Select Commodity Type",
      ],
      errorList: {
        fk_sline_id: "",
        // commodity_type: "",
      },
      selectDateFormat,

      isLoading: false,
      validate: false,

      docURL: URL_BASE_DOC,

      commodityTypeNameList: [
        {
          commodityTypeVal: "Others",
          commodityTypeText: "GENERAL",
        },
        {
          commodityTypeVal: "Reefer",
          commodityTypeText: "REEFER",
        },
        {
          commodityTypeVal: "Hazardous",
          commodityTypeText: "HAZ",
        },
      ],
    };
  },

  mounted() {},
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    Loading,
    MultiSelect,
    CustomLoader,
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },
  computed: {
    disbleLead() {
      return this.enqPriceEngineForm.enq_price_engine_id != "" ? true : false;
    },
    locationList() {
      return this.getlocationListData;
    },
    PortDischargeList() {
      return this.getPortDischargeList;
    },
  },
  methods: {
    CheckValueNumbers(item, arr) {
      if (!isNaN(item)) {
        if (Number.isInteger(item)) {
        }
      } else {
        this.alert.content = "Please Enter Only Integer and Decimal Values";
        this.$refs["addPop"].open();
      }
    },
    handleWheel(event) {
      // Prevent scrolling while the input is focused
      if (document.activeElement === event.target) {
        event.preventDefault();
      }
    },
    addPricingEngineCount() {
      let obj = {
        enq_price_engine_id: "",
        commodity_type: "",
        // fk_por_id: "",
        fk_pol_id: "",
        fk_pod_id: "",
        // fk_fpod_id: "",
        fk_currency_id: "1",
        fk_cont_type_id: "1",
        of_twenty_gp: "",
        twenty_gp_add_charg: "",
        tot_twenty_gp: "",
        // of_fourty_hc: "",
        // fourty_hc_add_charg: "",
        // tot_fourty_hc: "",
        free_time: "",
        validity_date: "",
        handover: "",
        expire_status: "",

        commodity_type_err: "",
        // fk_por_id_err: "",
        fk_pol_id_err: "",
        fk_pod_id_err: "",
        // fk_fpod_id_err: "",
        fk_currency_id_err: "",
        fk_cont_type_id_err: "",
        of_twenty_gp_err: "",
        twenty_gp_add_charg_err: "",
        tot_twenty_gp_err: "",
        // of_fourty_hc_err: "",
        // fourty_hc_add_charg_err: "",
        // tot_fourty_hc_err: "",
        free_time_err: "",
        validity_date_err: "",
        validity_date_expire_status_err: "",
        handover_err: "",
        pre_validityDate: "",
        is_new: 1,
      };
      this.PricingEngineCountArr.push(obj);
      this.checkValidityStatus(this.PricingEngineCountArr);
    },
    removePricingEngineCount(index) {
      this.PricingEngineCountArr.splice(index, 1);
      this.TotalAMT();
    },
    TotalAMT(itm, idx) {
      let TotAMT20 = 0;
      let amount20 = 0;
      let amount120 = 0;
      let TotAMT40 = 0;
      let amount40 = 0;
      let amount140 = 0;
      // 20 GP
      if (isNaN(itm.of_twenty_gp) || itm.of_twenty_gp == "" || itm.of_twenty_gp == 0) {
        amount20 = 0;
      } else {
        amount20 = itm.of_twenty_gp;
      }

      if (
        isNaN(itm.twenty_gp_add_charg) ||
        itm.twenty_gp_add_charg == "" ||
        itm.twenty_gp_add_charg == 0
      ) {
        amount120 = 0;
      } else {
        amount120 = itm.twenty_gp_add_charg;
      }

      if (TotAMT20 == 0) {
        TotAMT20 = parseFloat(amount20) + parseFloat(amount120);
      } else {
        TotAMT20 = parseFloat(TotAMT20) + parseFloat(amount20) + parseFloat(amount120);
      }

      // 40 HC

      // if (isNaN(itm.of_fourty_hc) || itm.of_fourty_hc == "" || itm.of_fourty_hc == 0) {
      //   amount40 = 0;
      // } else {
      //   amount40 = itm.of_fourty_hc;
      // }

      // if (
      //   isNaN(itm.fourty_hc_add_charg) ||
      //   itm.fourty_hc_add_charg == "" ||
      //   itm.fourty_hc_add_charg == 0
      // ) {
      //   amount140 = 0;
      // } else {
      //   amount140 = itm.fourty_hc_add_charg;
      // }

      // if (TotAMT40 == 0) {
      //   TotAMT40 = parseFloat(amount40) + parseFloat(amount140);
      // } else {
      //   TotAMT40 = parseFloat(TotAMT40) + parseFloat(amount40) + parseFloat(amount140);
      // }
      itm.tot_twenty_gp = TotAMT20;
      // itm.tot_fourty_hc = TotAMT40;
    },
    calculateMinDate() {
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      // 15th two months prior
      const minDate = new Date(today);
      minDate.setMonth(minDate.getMonth());
      return minDate.setDate(now.getDate());
    },
    validatePriceEngineDetail() {
      let validate_new = true;
      let errCount = 0;

      let MainARR = this.PricingEngineCountArr;
      for (let j = 0; j < MainARR.length; j++) {
        if (MainARR[j].commodity_type == "") {
          this.PricingEngineCountArr[j].commodity_type_err =
            "Commodity " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
        } else {
          this.PricingEngineCountArr[j].commodity_type_err = "";
          validate_new = true;
        }
        // if (MainARR[j].fk_por_id == "") {
        //   this.PricingEngineCountArr[j].fk_por_id_err =
        //     "POR " + parseInt(j + 1) + " Field is Required";
        //   validate_new = false;
        //   ++errCount;
        // } else {
        //   this.PricingEngineCountArr[j].fk_por_id_err = "";
        //   validate_new = true;
        // }

        if (MainARR[j].fk_pol_id == "") {
          this.PricingEngineCountArr[j].fk_pol_id_err =
            "POL " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
        } else {
          this.PricingEngineCountArr[j].fk_pol_id_err = "";
          validate_new = true;
        }

        if (MainARR[j].fk_pod_id == "") {
          this.PricingEngineCountArr[j].fk_pod_id_err =
            "POD " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
        } else {
          this.PricingEngineCountArr[j].fk_pod_id_err = "";
          validate_new = true;
        }

        // if (MainARR[j].fk_fpod_id == "") {
        //   this.PricingEngineCountArr[j].fk_fpod_id_err =
        //     "FPOD " + parseInt(j + 1) + " Field is Required";
        //   validate_new = false;
        //   ++errCount;
        // } else {
        //   this.PricingEngineCountArr[j].fk_fpod_id_err = "";
        //   validate_new = true;
        // }

        if (MainARR[j].fk_currency_id == "") {
          this.PricingEngineCountArr[j].fk_currency_id_err =
            "Currency " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
        } else {
          this.PricingEngineCountArr[j].fk_currency_id_err = "";
          validate_new = true;
        }

        if (MainARR[j].fk_cont_type_id == "") {
          this.PricingEngineCountArr[j].fk_cont_type_id_err =
            "Container Type " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
        } else {
          this.PricingEngineCountArr[j].fk_cont_type_id_err = "";
          validate_new = true;
        }

        if (MainARR[j].of_twenty_gp == "") {
          this.PricingEngineCountArr[j].of_twenty_gp_err =
            "OF-20 GP " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
        } else {
          this.PricingEngineCountArr[j].of_twenty_gp_err = "";
          validate_new = true;
        }

        if (MainARR[j].twenty_gp_add_charg == "") {
          this.PricingEngineCountArr[j].twenty_gp_add_charg_err =
            "Add Charges 20-GP " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
        } else {
          this.PricingEngineCountArr[j].twenty_gp_add_charg_err = "";
          validate_new = true;
        }

        if (MainARR[j].tot_twenty_gp == "") {
          this.PricingEngineCountArr[j].tot_twenty_gp_err =
            "Total 20-GP " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
        } else {
          this.PricingEngineCountArr[j].tot_twenty_gp_err = "";
          validate_new = true;
        }

        // if (MainARR[j].of_fourty_hc == "") {
        //   this.PricingEngineCountArr[j].of_fourty_hc_err =
        //     "OF-40 HC " + parseInt(j + 1) + " Field is Required";
        //   validate_new = false;
        //   ++errCount;
        // } else {
        //   this.PricingEngineCountArr[j].of_fourty_hc_err = "";
        //   validate_new = true;
        // }

        // if (MainARR[j].fourty_hc_add_charg == "") {
        //   this.PricingEngineCountArr[j].fourty_hc_add_charg_err =
        //     "Add Charges 40-HC " + parseInt(j + 1) + " Field is Required";
        //   validate_new = false;
        //   ++errCount;
        // } else {
        //   this.PricingEngineCountArr[j].fourty_hc_add_charg_err = "";
        //   validate_new = true;
        // }

        // if (MainARR[j].tot_fourty_hc == "") {
        //   this.PricingEngineCountArr[j].tot_fourty_hc_err =
        //     "Total 40-HC " + parseInt(j + 1) + " Field is Required";
        //   validate_new = false;
        //   ++errCount;
        // } else {
        //   this.PricingEngineCountArr[j].tot_fourty_hc_err = "";
        //   validate_new = true;
        // }

        if (MainARR[j].free_time == "") {
          this.PricingEngineCountArr[j].free_time_err =
            "Free Time " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
        } else {
          this.PricingEngineCountArr[j].free_time_err = "";
          validate_new = true;
        }

        if (MainARR[j].validity_date == "") {
          this.PricingEngineCountArr[j].validity_date_err =
            "Validity Date " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
        } else {
          this.PricingEngineCountArr[j].validity_date_err = "";
          validate_new = true;
        }
        // if (MainARR[j].is_new == 1) {
        // alert(MainARR[j].expire_status)
        if (MainARR[j].expire_status == "Expired") {
          this.PricingEngineCountArr[j].validity_date_expire_status_err =
            "Your Validity Date " + parseInt(j + 1) + " Expired Choose Another Date";
          this.alert.content =
            "Your Validity Date " + parseInt(j + 1) + " Expired Choose Another Date";
          this.$refs["addPop"].open();
          validate_new = false;
          ++errCount;
        } else {
          this.PricingEngineCountArr[j].validity_date_expire_status_err = "";
          validate_new = true;
        }
        // }
        if (MainARR[j].handover == "") {
          this.PricingEngineCountArr[j].handover_err =
            "Handover " + parseInt(j + 1) + " Field is Required";
          validate_new = false;
          ++errCount;
        } else {
          this.PricingEngineCountArr[j].handover_err = "";
          validate_new = true;
        }
      }
      // alert(errCount);
      if (errCount > 0) {
        this.validatePriceEngine = false;
      } else {
        this.validatePriceEngine = true;
      }
    },

    goBack() {
      window.history.go(-1);
    },

    validateEnqPriceEngine() {
      let validate_new = true;
      Object.keys(this.errorList).map((x, index) => {
        if (
          this.enqPriceEngineForm[x] == "" ||
          this.enqPriceEngineForm[x] == undefined ||
          this.enqPriceEngineForm[x] == null
        ) {
          this.errorList[x] = this.enqPriceEngineFormError[index];
          validate_new = false;
        }
      });
      if (validate_new != true) {
        this.validate = false;
        return;
      } else {
        this.validate = true;
      }
    },

    addenqPriceEngineForm() {
      this.validateEnqPriceEngine();
      this.validatePriceEngineDetail();
      this.enqPriceEngineForm.TypeofAdd = "EnqPriceEngine Master Add";

      this.PricingEngineCountArr.forEach((val, ind) => {
        // this.$store.getters["enqPriceEngineDropdown/getAllEnqPriceEnginePORDDList"].forEach((val1, ind1) => {
        //   if (val.fk_por_id === val1.pickupId) {
        //     val.por_name = val2.pickupLocation;
        //   }
        // });

        this.$store.getters[
          "enqPriceEngineDropdown/getAllEnqPriceEnginePOLDDList"
        ].forEach((val2, ind12) => {
          if (val.fk_pol_id === val2.pickupId) {
            val.pol_name = val2.pickupLocation;
          }
        });

        this.$store.getters[
          "enqPriceEngineDropdown/getAllEnqPriceEnginePODDDList"
        ].forEach((val3, ind3) => {
          if (val.fk_pod_id === val3.pickupId) {
            val.pod_name = val3.pickupLocation;
          }
        });

        // this.$store.getters[
        //   "enqPriceEngineDropdown/getAllEnqPriceEnginePODDDList"
        // ].forEach((val5, ind5) => {
        //   if (val.fk_fpod_id === val5.pickupId) {
        //     val.fpod_name = val5.pickupLocation;
        //   }
        // });

        this.$store.getters["common/getAllCurrencyList"].forEach((val4, ind4) => {
          if (val.fk_currency_id === val4.currency_id) {
            val.currency_name = val4.currencyCode;
          }
        });

        this.$store.getters["common/getAllContainerTypeList"].forEach((val5, ind5) => {
          if (val.fk_cont_type_id === val5.containerTypeId) {
            val.cont_type = val5.containerType;
          }
        });
      });
      // alert(this.validatePriceEngine);
      console.log("enqPriceEngineForm=>", this.PricingEngineCountArr);
      // console.log("errorList=>", this.errorList);
      if (this.validate == false || this.validatePriceEngine == false) return false;
      this.enqPriceEngineForm.PricingEngineCount = this.PricingEngineCountArr;
      this.isLoading = true;

      let payload = {
        itemCode: "add_enq_price_engine_details",
        enqPriceEngineForm: this.enqPriceEngineForm,
      };
      payload = JSON.stringify(payload);
      console.log("payload=>", payload);
      // return false;
      if (this.validate != false) {
        LeadService.getAllEnqPricingList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (data.enq_price_engine_id != "" && data.enq_price_engine_id != undefined) {
              if (data.find == 1 || data.find == 2) {
                this.alert.content = data.MSG;
              } else {
                this.alert.content = data.MSG;
              }
            } else {
              this.alert.content = data.MSG;
            }
            this.isLoading = false;
            this.$refs["addPop"].open();
            if (data.flag == true) {
              // this.$router.push({
              //   path: "/enqPrice/enqPriceList",
              // });
            }
          })
          .catch((error) => {
            console.log("Catch on addenqPriceEngineForm Error: ", error);
          });
      }
    },

    getSingleEnqPriceEngine(enq_price_engine_id, fk_sline_id) {
      this.PricingEngineCountArr = [];
      this.isLoading = true;
      let payload = {
        itemCode: "getSlineBaseSingleEnqPriceEngineList",
        fk_sline_id: fk_sline_id,
        enq_price_engine_id: enq_price_engine_id,
      };
      LeadService.getAllEnqPricingList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (data.getSlineBaseSingleEnqPriceEngineList) {
              this.PricingEngineCountArr = data.getSlineBaseSingleEnqPriceEngineList;
              this.enqPriceEngineForm.fk_sline_id =
                data.getSlineBaseSingleEnqPriceEngineList[0].fk_sline_id;
              this.enqPriceEngineForm.commodity_type =
                data.getSlineBaseSingleEnqPriceEngineList[0].commodity_type;
              this.enqPriceEngineForm.enq_price_engine_id =
                data.getSlineBaseSingleEnqPriceEngineList[0].enq_price_engine_id;
              this.PricingEngineCountArr.map((engine) => {
                engine.is_new = 2;
                engine.pre_validityDate = engine.validity_date;
              });
              this.checkValidityStatus(this.PricingEngineCountArr);
            } else {
              let obj = {
                enq_price_engine_id: "",
                commodity_type: "",
                // fk_por_id: "",
                fk_pol_id: "",
                fk_pod_id: "",
                // fk_fpod_id: "",
                fk_currency_id: "1",
                fk_cont_type_id: "1",
                of_twenty_gp: "",
                twenty_gp_add_charg: "",
                tot_twenty_gp: "",
                // of_fourty_hc: "",
                // fourty_hc_add_charg: "",
                // tot_fourty_hc: "",
                free_time: "",
                validity_date: "",
                handover: "",
                expire_status: "",

                commodity_type_err: "",
                // fk_por_id_err: "",
                fk_pol_id_err: "",
                fk_pod_id_err: "",
                // fk_fpod_id_err: "",
                fk_currency_id_err: "",
                fk_cont_type_id_err: "",
                of_twenty_gp_err: "",
                twenty_gp_add_charg_err: "",
                tot_twenty_gp_err: "",
                // of_fourty_hc_err: "",
                // fourty_hc_add_charg_err: "",
                // tot_fourty_hc_err: "",
                free_time_err: "",
                validity_date_err: "",
                validity_date_expire_status_err: "",
                handover_err: "",
                pre_validityDate: "",
                is_new: 1,
              };
              this.PricingEngineCountArr.push(obj);
              this.checkValidityStatus(this.PricingEngineCountArr);
            }
            console.log(" Single SLine Base ENquiry Price Engine List response=>", data);
          }

          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on Single Lead Error: ", error);
        });
    },
    checkValidityStatus(pricingEngines) {
      const currentDate = new Date(); // Current date with time component
      const today = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate()
      ); // Get only the date part without time

      return pricingEngines.map((engine) => {
        engine.expire_status = "";

        if (engine.is_new === 2) {
          const validityDate = new Date(engine.validity_date);

          if (validityDate < today) {
            engine.expire_status = "Expired";
          } else {
            engine.expire_status = "Active";
          }
        } else {
          engine.expire_status = "Active";
        }
      });
    },

    getSlineBaseEnqPriceEngine(id) {
      this.PricingEngineCountArr = [];
      this.isLoading = true;
      let payload = {
        itemCode: "getSlineBaseEnqPriceEngineList",
        fk_sline_id: id,
      };
      LeadService.getAllEnqPricingList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (data.getSlineBaseEnqPriceEngineList.length > 0) {
              this.PricingEngineCountArr = data.getSlineBaseEnqPriceEngineList;
              this.enqPriceEngineForm.fk_sline_id =
                data.getSlineBaseEnqPriceEngineList[0].fk_sline_id;
              this.enqPriceEngineForm.commodity_type =
                data.getSlineBaseEnqPriceEngineList[0].commodity_type;
              this.enqPriceEngineForm.enq_price_engine_id =
                data.getSlineBaseEnqPriceEngineList[0].enq_price_engine_id;
              this.PricingEngineCountArr.map((engine) => {
                engine.is_new = 2;
                engine.pre_validityDate = engine.validity_date;
              });
              this.checkValidityStatus(this.PricingEngineCountArr);
            } else {
              let obj = {
                enq_price_engine_id: "",
                commodity_type: "",
                // fk_por_id: "",
                fk_pol_id: "",
                fk_pod_id: "",
                // fk_fpod_id: "",
                fk_currency_id: "1",
                fk_cont_type_id: "1",
                of_twenty_gp: "",
                twenty_gp_add_charg: "",
                tot_twenty_gp: "",
                // of_fourty_hc: "",
                // fourty_hc_add_charg: "",
                // tot_fourty_hc: "",
                free_time: "",
                validity_date: "",
                handover: "",
                expire_status: "",

                commodity_type_err: "",
                // fk_por_id_err: "",
                fk_pol_id_err: "",
                fk_pod_id_err: "",
                // fk_fpod_id_err: "",
                fk_currency_id_err: "",
                fk_cont_type_id_err: "",
                of_twenty_gp_err: "",
                twenty_gp_add_charg_err: "",
                tot_twenty_gp_err: "",
                // of_fourty_hc_err: "",
                // fourty_hc_add_charg_err: "",
                // tot_fourty_hc_err: "",
                free_time_err: "",
                validity_date_err: "",
                validity_date_expire_status_err: "",
                handover_err: "",
                pre_validityDate: "",
                is_new: 1,
              };
              this.PricingEngineCountArr.push(obj);
              this.checkValidityStatus(this.PricingEngineCountArr);
            }
            console.log(" Single SLine Base ENquiry Price Engine List response=>", data);
          }

          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on Single Lead Error: ", error);
        });
    },

    previousFFView() {
      window.history.go(-1);
    },

    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };
      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
              this.vmodelArray = result;
              console.log("self=>", self);
              console.log("vmodelArray=>", vmodelArray);
              console.log("self[vmodelArray]=>", self[vmodelArray]);
              console.log("this.vmodelArray=>", this.vmodelArray);
            }
          }
        });
      }
    },
    getLocations() {
      const option = {
        data: this.options1,
        categoryType: "hh",
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/getLocationList.php`,
        data: JSON.stringify(option),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { data } = result;
          this.options1 = data.userDataList;
          this.$refs["location-modal"].show();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    dateDifference(pre_validityDate, current_date) {
      let date1 = new Date(pre_validityDate); //7/13/2010
      let date2 = new Date(current_date); //12/15/2010

      let diffTime = Math.abs(date2 - date1);
      let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays;
    },
    currentDate() {
      var currentDate = new Date();
      var currentDateWithFormat = new Date().toJSON().slice(0, 10).replace(/-/g, "-");
      return currentDateWithFormat;
    },
    convert(str) {
      var date = new Date(str),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
      return [date.getFullYear(), mnth, day].join("-");
    },
    validityDateDifference(pre_validityDate, validity_date) {
      if (validity_date) {
        const today = new Date();
        const validityDate = new Date(validity_date);
        validityDate.setHours(0, 0, 0, 0); // Set time to midnight for accurate comparison

        const differenceInTime = validityDate.getTime() - today.getTime();
        const differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24));

        return differenceInDays;
      } else {
        return null; // Return null if no validity date is selected
      }
    },
    updateValidityDate(item, pre_validityDate, validity_date) {
      let current_date = this.currentDate();
      console.log("current_date=>", current_date);
      console.log("pre_validityDate=>", item.pre_validityDate);
      console.log("validity_date=>", item.validity_date);
      console.log("validity_date2=>", item);
      // return false;
      let days_count = this.validityDateDifference(
        item.pre_validityDate,
        item.validity_date
      );

      if (item.validity_date && days_count > 0) {
        this.isLoading = true;
        let payload = {
          itemCode: "enq_price_engine_update_validityDate",
          tableName: "enq_price_engine_master",
          tableKeyVal: item.enq_price_engine_id,
          tableKey: "enq_price_engine_id",
          setFieldKeyVal: this.convert(item.validity_date),
          setFieldKey: "validity_date",
          pre_validityDate: item.pre_validityDate,
          changedValues: [item],
        };
        LeadService.getAllEnqPricingList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (status == 200 && data) {
              if (data.find == 1 || data.find == 2) {
                this.alert.content = data.MSG;
              } else {
                this.alert.content = data.MSG;
              }
              this.isLoading = false;
              this.$refs["addPop"].open();
              if (
                this.$sessionsStorage.get("edit_enq_price_engine_id") != undefined &&
                this.$sessionsStorage.get("edit_enq_price_engine_id") != null &&
                this.$sessionsStorage.get("edit_enq_price_engine_id") != ""
              ) {
                // alert(this.$sessionsStorage.get("edit_enq_price_engine_id"))
                this.getSingleEnqPriceEngine(
                  this.$sessionsStorage.get("edit_enq_price_engine_id"),
                  this.$sessionsStorage.get("edit_enq_price_engine_sline_id")
                );
              } else {
                this.getSlineBaseEnqPriceEngine(enqPriceEngineForm.fk_sline_id);
              }
            }

            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on Single Lead Error: ", error);
          });
      } else {
        this.alert.content = "Please Enter Validity Date";
        this.$refs["addPop"].open();
      }
    },
  },
};
</script>
<style scoped>
.quotePMargin {
  margin: 0px;
  text-align: left !important;
}
.md-direction-bottom-right {
  width: 18% !important;
}

.md-flex-xsmall-100 {
  min-width: 100%;

  flex: 0 1 100%;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// upsertPricingEngine.vue?828992b4